import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import {
  getEmailVerificationPlanRequest,
  getLeadFinderOneTimePlansRequest,
  purchaseAiCreditsRequest,
  calculateCreditsPricesRequest,
  purchaseCreditsRequest,
} from '../../extra-actions';

import PurchaseCreditsModal from './purchase-credits-modal';
import { GetEmailVerificationPlanResponse } from '../../types';
import {
  PurchaseAiCreditsRequest,
  PurchaseAiCreditsResponse,
} from '../../types/ai-credits';
import {
  CalculateCreditsPricesRequest,
  PurchaseCreditsRequest,
  PurchaseCreditsType,
} from '../../types/purchase-credits';
import {
  resetCalculateCreditsPricesRequest,
  resetPurchaseCreditsRequest,
} from '../../billing-subscription-slice';
import { selectPaddleCustomerId } from '../../../../../home/home-slice';

const mapStateToProps = (state: RootState) => ({
  getEmailVerificationPlanRequestStatus:
    state.billingAndSubscription.getEmailVerificationPlanRequest.status,
  getEmailVerificationPlanResponse:
    state.billingAndSubscription.getEmailVerificationPlanResponse,
  getLeadFinderOneTimePlansRequestStatus:
    state.billingAndSubscription.getLeadFinderOneTimePlansRequest.status,
  getLeadFinderOneTimePlansResponse:
    state.billingAndSubscription.getLeadFinderOneTimePlansResponse,
  isDemoAccount: state.home.isDemoAccount,
  purchaseAiCreditsRequestStatus:
    state.billingAndSubscription.purchaseAiCreditsRequest.status,
  purchaseAiCreditsRequestResponse:
    state.billingAndSubscription.purchaseAiCreditsResponse,
  userEmail: state.home?.email,
  shAccountId: state.home?.shAccountId,
  trackingId: state.home?.trackingId,

  calculateCreditsPricesRequestStatus:
    state.billingAndSubscription.calculateCreditsPricesRequest.status,
  calculateCreditsPricesResponse:
    state.billingAndSubscription.calculateCreditsPricesResponse,

  purchaseCreditsRequestStatus:
    state.billingAndSubscription.purchaseCreditsRequest.status,
  purchaseCreditsResponse: state.billingAndSubscription.purchaseCreditsResponse,

  paymentProvider: state.home?.paymentProvider,
  paddleCustomerId: selectPaddleCustomerId(state),
});

const mapDispatchToProps = {
  sendGetEmailVerificationPlanRequest: () => getEmailVerificationPlanRequest(),
  sendGetLeadFinderOneTimePlansRequest: () =>
    getLeadFinderOneTimePlansRequest(),
  sendPurchaseAiCreditsRequest: (payload: PurchaseAiCreditsRequest) =>
    purchaseAiCreditsRequest(payload),
  sendCalculateCreditsPricesRequest: (payload: CalculateCreditsPricesRequest) =>
    calculateCreditsPricesRequest(payload),
  sendPurchaseCreditsRequest: (payload: PurchaseCreditsRequest) =>
    purchaseCreditsRequest(payload),

  resetCalculateCreditsPricesRequest: () =>
    resetCalculateCreditsPricesRequest(),
  resetPurchaseCreditsRequest: () => resetPurchaseCreditsRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show?: boolean;
  evCreditPlans?: GetEmailVerificationPlanResponse[];
  onClose: () => void;
  onBuyCredits: (stripeCardToken: string, planId: number) => void;
  isPurchaseEmailVerificationCreditsLoading?: boolean;
  remainingCredit?: number;
  sequenceName?: string;
  currentPlan: string;
  type: 'email-verification' | 'lead-finder' | 'ai-credits';
  openTalkToSalesChat?: () => void;
  showPlansLoading?: boolean;
  avoidStripeCheckout?: boolean;
  paymentProvider?: string;
  purchaseAiCreditsRequestResponse: PurchaseAiCreditsResponse;
  /**
   * Callback when Paddle checkout completes successfully
   * Parent should start polling for transaction status
   * @param orderId - The order ID from the purchase response
   */
  onCheckoutComplete?: (orderId?: string) => void;
  onPaymentFailed?: () => void;
};
export default connector(PurchaseCreditsModal);
